import { render, staticRenderFns } from "./nftLogin.vue?vue&type=template&id=28165d1a&scoped=true&"
import script from "./nftLogin.vue?vue&type=script&lang=js&"
export * from "./nftLogin.vue?vue&type=script&lang=js&"
import style0 from "./nftLogin.vue?vue&type=style&index=0&id=28165d1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28165d1a",
  null
  
)

export default component.exports